export default __webpack_public_path__ + "static/media/data-submit.dd50429f.svg";